import { createUseStyles } from "react-jss";

export interface MelaTooltipStyleProps {
  fullWidth: boolean;
  maxWidth: number;
  interactive: boolean;
  tone: "dark" | "light";
}

const useMelaTooltipStyles = createUseStyles({
  trigger: (props: MelaTooltipStyleProps) => ({
    display: "inline-flex",
    alignItems: "center",
    width: props.fullWidth ? "100%" : "fit-content",
    maxWidth: props.fullWidth ? "100%" : "none",
  }),
  content: (props: MelaTooltipStyleProps) => ({
    position: "relative",
    zIndex: 30050,
    maxWidth: props.maxWidth,
    padding: "0.5rem 0.75rem",
    borderRadius: 10,
    background:
      props.tone === "light"
        ? "var(--mela-surface-card)"
        : "var(--mela-color-tooltip-bg)",
    border:
      props.tone === "light"
        ? "1px solid var(--mela-border-subtle)"
        : "1px solid var(--mela-color-tooltip-border)",
    color:
      props.tone === "light"
        ? "var(--mela-text-primary)"
        : "var(--mela-color-tooltip-text)",
    boxShadow:
      props.tone === "light"
        ? "0 18px 44px rgba(15, 23, 42, 0.18), 0 4px 12px rgba(15, 23, 42, 0.08)"
        : "var(--mela-color-tooltip-shadow)",
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.76rem",
    fontWeight: 500,
    lineHeight: 1.35,
    letterSpacing: 0,
    pointerEvents: props.interactive ? "auto" : "none",
    wordBreak: "break-word",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    transformOrigin: "center",
    willChange: "opacity, transform",
  }),
  contentEnter: {
    animation: "$tooltipEnter 320ms cubic-bezier(0.19, 1, 0.22, 1)",
  },
  contentExit: {
    animation: "$tooltipExit 260ms cubic-bezier(0.19, 1, 0.22, 1) forwards",
  },
  arrow: {
    fill: "var(--mela-color-tooltip-bg)",
    stroke: "var(--mela-color-tooltip-border)",
    strokeWidth: 1,
  },
  "@keyframes tooltipEnter": {
    "0%": {
      opacity: 0,
      transform: "translateY(1px) scale(0.998)",
    },
    "40%": {
      opacity: 0.72,
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0) scale(1)",
    },
  },
  "@keyframes tooltipExit": {
    "0%": {
      opacity: 1,
      transform: "translateY(0) scale(1)",
    },
    "60%": {
      opacity: 0.5,
    },
    "100%": {
      opacity: 0,
      transform: "translateY(1px) scale(0.998)",
    },
  },
});

export default useMelaTooltipStyles;
